<template lang="html">
    <div class="previewDBXX-page">
        <Slogan v-show="this.dbxx.length != 0" theTitle="担保信息"/>
        <van-cell-group class="dbxx-box" v-for="(item, index) in this.dbxx"
                        :key="index">
            <van-field
                    v-if="item.cDbfs == 1"
                    v-model="dbfs1"
                    readonly
                    label="担保方式"
            ></van-field>
            <van-field
                    v-if="item.cDbfs == 2"
                    v-model="dbfs2"
                    readonly
                    label="担保方式"
            ></van-field>
            <van-field
                    v-if="item.cDbfs == 3"
                    v-model="dbfs3"
                    readonly
                    label="担保方式"
            ></van-field>
            <van-field
                    v-if="item.cDbfs == 4"
                    v-model="dbfs4"
                    readonly
                    label="担保方式"
            ></van-field>
            <van-field
                    v-if="item.cDbfs == 5"
                    v-model="dbfs5"
                    readonly
                    label="担保方式"
            ></van-field>
            <van-field
                    v-model="item.cDbr"
                    readonly
                    label="担保人"
            ></van-field>
            <van-field
                    v-if="item.cDbfs == 2"
                    v-model="item.cDbwmc"
                    readonly
                    label="担保物名称"
                     @click="toastJointCcxx(item.cDbwmc)"
            ></van-field>

            <van-field
                    v-if="item.cDbfs == 5"
                    v-model="item.cBxgsmc"
                    readonly
                    label="担保机构名称"
                    @click="toastJointCcxx(item.cBxgsmc)"
            ></van-field>

           <van-field
                   v-if="item.cDbfs == 5 && item.nSysbuy == 1"
                   v-model="item.cBdh"
                   readonly
                   label="保单号"
                   @click="toastJointCcxx(item.cBdh)"
           ></van-field>
            <van-field
                    v-if="item.cDbfs == 3 || item.cDbfs == 4"
                    v-model="item.cclx"
                    readonly
                    :label="item.cclxmc"
            ></van-field>
            <van-field
                    v-model="item.nDbjz"
                    readonly
                    label="担保价值(元)"
            ></van-field>
            <van-field
                    v-model="item.cDbsm"
                    readonly
                    label="担保说明"
                    @click="toastJointCcxx(item.cDbsm)"
            ></van-field>
        </van-cell-group>
        <p class="fd-zjz-content" v-if="this.dbxx.length">担保总价值：{{zjz}}元</p>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import { Toast } from 'vant';
    import {typeDbfs,typeCclx,accAdd,typeSddy} from '../../../filters/index'

    export default {
        components: {
            Slogan
        },
        // 注入
        inject: ['bqid'],
        data() {
            return {
                dbxx: [],
                bz: "",
                dbfs1: "",
                dbfs2: "",
                dbfs3: "",
                dbfs4: "",
                dbfs5: ""
            }
        },
        computed: {
            // 担保总价值
            zjz() {
                let num = 0
                this.dbxx.map((item) => {
                    num += Number(item.nDbjz) * 100
                })
                return (num/100).toFixed(2)
            },
        },
        methods: {
             toastJointCcxx(value){
                if(!value){
                     return
                 }
                Toast(value);
            },
            getCcxsList() {
                this.$axios.get('ssbq/api/dbxxs' + "?time=" + new Date().getTime() + "&bqid=" + this.bqid).then(res => {
                    //代码值特殊处理
                    res.data.map((item, index) => {
                        let dbxxs = {}
                        if(item.cDbfs == 3){
                            this.dbfs3 = "设定抵押"
                            dbxxs.cclxmc = "抵押财产类型"
                        }else if(item.cDbfs == 4){
                            this.dbfs4 = "设定质押"
                            dbxxs.cclxmc = "质押财产类型"
                        }else if(item.cDbfs == 1){
                            this.dbfs1 = "交纳保证金"
                        }else if(item.cDbfs == 2){
                            this.dbfs2 = "提供保证人"
                        }else if(item.cDbfs == 5){
                            this.dbfs5 = "保险公司诉责险"
                        }
                        dbxxs.cDbfs = item.cDbfs
                        dbxxs.cDbr = item.cDbr
                        dbxxs.cDbwmc = item.cDbwmc
                        dbxxs.cBxgsmc = item.cBxgsmc
                        dbxxs.nDbjz = item.nDbjz
                        dbxxs.cDbsm = item.cDbsm
                        dbxxs.cclx = typeSddy(item.cCclx)
                        dbxxs.cBdh = item.cBdh
                        dbxxs.nSysbuy = item.nSysbuy
                        this.dbxx.push(dbxxs)
                    })
                })

            }
        },
        mounted() {
            this.getCcxsList()
        }
    }
</script>

<style lang="less" scoped>
    .fd-zjz-content{
        margin-top: -11px;
        padding-right: 18px;
        height: 1.33333rem;
        line-height: 1.33333rem;
        text-align: right;
        background: #fff;
    }
</style>
